import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";
import { useDispatch, useSelector } from "react-redux";
import {
  Update,
  GetAll,
  GetSingle,
} from "../../../../../features/admin/role_permmission/role/Slice";
import { AllPermmission } from "../../../../../features/admin/common/Slice";
const Edit_Role = ({
  show,
  handleClose,
  editId,
  setShow,
  setErr,
  setShowError,
  setSuccess,
}) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  console.log("editIdeditIdeditId", editId);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  // const [success, setSuccess] = useState(false);
  const [defaultValues, setDefaultValues] = useState({});
  const [searchName, setSearchName] = useState("");

  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.common.all_permission || []);
  // console.log("permissionspermissionspermissions", permissions);
  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      // console.log("resresresresresresGetSingle", res);
      setDefaultValues({
        id: res?.payload?.data?.id,
        name: res?.payload?.data?.name,
        description: res?.payload?.data?.description || "",
        status: res?.payload?.data?.status ? "1" : "0",
      });

      const selectedPermissionIds = Array.isArray(
        res?.payload?.data?.Roles_Permissions,
      )
        ? res?.payload?.data?.Roles_Permissions?.map(
            (permission) => permission.permission_id,
          )
        : [];

      setSelectedPermissions(selectedPermissionIds);
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };
  useEffect(() => {
    if (show && editId) {
      GetData(editId);
    }
  }, [show, editId]);

  const handlePermissionChange = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedPermissions.length === permissions.length) {
      // untick all
      setSelectedPermissions([]);
    } else {
      // tick all
      const allIds = permissions.map((perm) => perm.id);
      setSelectedPermissions(allIds);
    }
  };

  useEffect(() => {
    if (defaultValues?.id) {
      reset({
        name: defaultValues.name,
        description: defaultValues.description,
        status: defaultValues.status,
      });
    }
  }, [defaultValues, reset]);

  useEffect(() => {
    dispatch(AllPermmission({ name: searchName }));
  }, [dispatch, searchName]);

  useEffect(() => {
    if (permissions.length > 0 && selectedPermissions.length > 0) {
      setSelectedPermissions((prev) => [...prev]);
    }
  }, [permissions]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data.name);
      sendData.append("description", data.description || "");
      sendData.append("status", data.status);

      selectedPermissions.forEach((id) => {
        sendData.append("permission_id[]", id);
      });
      console.log("SENDING permissions:", selectedPermissions);

      const res = await dispatch(Update({ id: defaultValues.id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setSuccess(true);

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [showMap, setShowMap] = useState(false);
  const [hideForm, setHideForm] = useState(false);

  const [viewDoc, setViewDoc] = useState(false);

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];

  const [activeTab, setActiveTab] = useState("basic");

  const documentSectionRef = useRef(null);
  const basiSectionRef = useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "basic" && basiSectionRef.current) {
      basiSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if (tab === "document" && documentSectionRef.current) {
      documentSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (defaultValues?.id) {
      reset({
        name: defaultValues.name,
        description: defaultValues.description,
        status: defaultValues.status,
      });
    }
  }, [defaultValues, reset]);

  console.log("RESET STATUS:", defaultValues.status);

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas Edit_Role_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Role
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* form 2 */}
            <div className="white_container" ref={documentSectionRef}>
              <div className="common_form_div">
                <div className="row">
                  <div className="blue_form_box">
                    <div className="row">
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label>Role Name</Form.Label>
                          <Controller
                            name="name"
                            control={control}
                            rules={{ required: "Role name is required" }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="eg. LAB MANAGER"
                              />
                            )}
                          />

                          {errors?.name && (
                            <Form.Text className="text-danger">
                              {errors.name.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label>Role Description(Optional)</Form.Label>
                          <Controller
                            name="description"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="Type Description"
                              />
                            )}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <Form.Label>Current Status:</Form.Label>
                  </div>

                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="radio"
                        label="Active"
                        value="1"
                        className="green_text"
                        {...register("status", {
                          required: "Status is required",
                        })}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Inactive"
                        value="0"
                        className="red_text"
                        {...register("status")}
                      />
                    </div>
                    {errors?.instrument_name_id && (
                      <Form.Text className="text-danger">
                        {errors?.instrument_name_id?.message}
                      </Form.Text>
                    )}
                  </div>

                  <div className="search_form_div">
                    <div className="col-sm-12">
                      <Form.Group
                        className="form_group"
                        controlId="formBasicName"
                      >
                        <Form.Label>Search Permission For Role:</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Permissions"
                          value={searchName}
                          onChange={(e) => setSearchName(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="radio_holder">
                      <Form.Check
                        type="checkbox"
                        label="Select All"
                        checked={
                          permissions.length > 0 &&
                          selectedPermissions.length === permissions.length
                        }
                        onChange={handleSelectAll}
                      />
                    </div>
                  </div>

                  <div className="permission_list mt-3">
                    <div className="row">
                      {permissions?.map((perm) => (
                        <div className="col-sm-6" key={perm.id}>
                          <Form.Check
                            type="checkbox"
                            id={`perm_${perm.id}`}
                            label={perm.name}
                            checked={selectedPermissions.includes(
                              Number(perm.id),
                            )}
                            onChange={() => handlePermissionChange(perm.id)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="offcanvas_footer_holder">
              {/* {!success ? (
                <> */}
              <div className="btns_holder">
                <Gray_Btn btnText={"Cancel"} onClick={handleClose} />
                <Black_Submit_Btn btnText={"Submit"} type="submit" />
              </div>
              {/* <Refresh_btn /> */}
              {/* </>
              ) : (
                <Success_Toster successText={"Role Updated Successfully!"} />
              )} */}
            </div>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Edit_Role;
